import React, { useEffect, useRef } from "react";
import "./Services.css";

const SERVICES = [
  {
    icon: "📄",
    title: "Resume Enhancement",
    desc: "ATS-optimised, recruiter-ready resumes with one-on-one consultation to reflect your unique professional story.",
    color: "rgba(157,78,221,0.15)",
  },
  {
    icon: "🔗",
    title: "LinkedIn Optimization",
    desc: "Keyword-rich profiles that get discovered by top recruiters. We rewrite your headline, summary, and experience.",
    color: "rgba(91,24,154,0.15)",
  },
  {
    icon: "🧭",
    title: "Career Counselling",
    desc: "Personalised roadmaps by experienced advisors — clarify your path and act on it with laser focus and confidence.",
    color: "rgba(199,125,255,0.1)",
  },
  {
    icon: "💡",
    title: "Technical Training",
    desc: "Industry-aligned, hands-on sessions tailored to your target role. Build real-world competence that impresses.",
    color: "rgba(60,9,108,0.2)",
  },
  {
    icon: "🎯",
    title: "Interview Preparation",
    desc: "Mock sessions, common-question coaching, and salary negotiation strategy — walk into every interview prepared.",
    color: "rgba(157,78,221,0.12)",
  },
  {
    icon: "🏢",
    title: "Job Placement",
    desc: "Direct access to our curated employer network spanning IT, finance, healthcare, and operations. Your role is waiting.",
    color: "rgba(91,24,154,0.18)",
  },
];

const Services = () => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.08 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services" id="services" ref={ref}>
      <div className="services__header reveal">
        <span className="eyebrow">What We Offer</span>
        <h2 className="services__h2">End-to-End Career Solutions</h2>
        <p className="services__sub">
          Every service is designed to remove the friction between where you are
          and where you want to be.
        </p>
      </div>

      <div className="services__grid">
        {SERVICES.map((s, i) => (
          <div
            className="services__card glass glass-hover reveal"
            style={{ transitionDelay: `${i * 0.07}s`, "--card-color": s.color }}
            key={i}
          >
            <div className="services__icon-wrap">
              <span className="services__icon">{s.icon}</span>
              <div className="services__icon-glow" style={{ background: s.color }} />
            </div>
            <h3 className="services__title">{s.title}</h3>
            <p className="services__desc">{s.desc}</p>
            <div className="services__arrow">→</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
